var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',{staticClass:"is-size-3"}),(!_vm.isCloudMode)?[_c('IndoorNoGmapDisplay',{staticClass:"p-md"})]:[(!_vm.$isMobileSize())?_c('IndoorDisplay',{staticClass:"p-md"}):_c('IndoorDisplayMobile',{staticClass:"p-md"})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }